import { isFunction } from 'lodash/fp';

export function paramResolverMiddleware({ getState }) {
    return (next) => (action) => {
        if (isFunction(action.params)) {
            action.params = action.params(getState());
        }

        if (isFunction(action.payload)) {
            action.payload = action.payload(getState());
        }

        if (isFunction(action.context)) {
            action.context = action.context(getState());
        }

        if (isFunction(action.meta)) {
            action.meta = action.meta(getState());
        }

        if (isFunction(action.getSqlParams)) {
            action.getSqlParams = action.getSqlParams(getState());
        }

        return next(action);
    };
}
